// Taboola defaults for rugby, all editions.
//
// Notes:
// 1. 'team' => 'clubhouse', which only has a right-rail placement.

export default {
  'team': {
    'right-rail' : {
      'type': 'other',
      'mode': 'thumbnails-1x3',
      'container': 'taboola-right-rail-thumbnails',
      'target_type': 'mix'
    }
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/taboola.js